import { render, staticRenderFns } from "./EventiMaterialiComponent.vue?vue&type=template&id=6135d824"
import script from "./EventiMaterialiComponent.vue?vue&type=script&lang=js"
export * from "./EventiMaterialiComponent.vue?vue&type=script&lang=js"
import style0 from "./EventiMaterialiComponent.vue?vue&type=style&index=0&id=6135d824&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports